module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-74.ab39f22.woff2";